export const EMOTIONAL_AWARENESS_GUIDE = {
  path: "/emotional-awareness",
  url: "https://ahavibes.xyz/emotional-awareness",
  headline:
    "Emotional Awareness: A Practical Guide to Naming, Examining, and Responding to Your Emotions",
  description:
    "Learn to recognize emotions as they happen, map your patterns and triggers, choose deliberate responses, and build steadiness after setbacks.",
  sections: [
    {
      id: "introduction",
      position: 1,
      name: "Introduction",
      description:
        "Why emotional awareness matters and how it changes the way you respond to life.",
    },
    {
      id: "emotional-awareness-explained",
      position: 2,
      name: "Emotional Awareness Explained",
      description:
        "What emotional awareness is and why it is the foundation of emotional intelligence.",
    },
    {
      id: "recognizing-emotional-patterns",
      position: 3,
      name: "Recognizing Emotional Patterns",
      description:
        "How repeated emotional experiences reveal patterns you can prepare for and change.",
    },
    {
      id: "naming-emotions",
      position: 4,
      name: "Naming Emotions",
      description:
        "How precise emotional language turns confusion into clarity and reveals what you need.",
    },
    {
      id: "emotional-triggers",
      position: 5,
      name: "Emotional Triggers",
      description:
        "What activates strong reactions and how to understand what inside you responded.",
    },
    {
      id: "emotional-regulation",
      position: 6,
      name: "Emotional Regulation",
      description:
        "Managing emotions without suppressing them through pause, examined thoughts, and deliberate action.",
    },
    {
      id: "understanding-shame",
      position: 7,
      name: "Understanding Shame",
      description:
        "How shame differs from guilt and how examining the interpretation behind it loosens the pattern.",
    },
    {
      id: "understanding-anger",
      position: 8,
      name: "Understanding Anger",
      description:
        "What anger protects underneath and how to turn it into examined insight.",
    },
    {
      id: "building-emotional-resilience",
      position: 9,
      name: "Building Emotional Resilience",
      description:
        "Habits that help you adapt, update your thinking, and continue moving forward after setbacks.",
    },
    {
      id: "bringing-it-together",
      position: 10,
      name: "Bringing It All Together",
      description:
        "Pause and examine: name the feeling, check the interpretation, then choose a deliberate response.",
    },
  ],
};
